<template>
  <BannerHowItWorks v-if="Object.keys(bannerData).length" :data="bannerData" />
  <div class="max-w-7xl mx-auto px-4 lg:px-0 py-5">
    <StepsHowItWorks v-if="Object.keys(stepsSectionData).length" :data="stepsSectionData" />
  </div>
  <QrCtaHowItWorks v-if="Object.keys(qrCtaData).length" v-bind="qrCtaData" />
</template>

<script setup lang="ts">
import { ref, watchEffect } from 'vue'
import { useDynamicTranslations } from '@/i18n'
import BannerHowItWorks from '@/components/modules/howitworks/Banner.vue'
import StepsHowItWorks from '@/components/modules/howitworks/StepsHowItWorks.vue'
import QrCtaHowItWorks from '@/components/modules/howitworks/QrCtaHowItWorks.vue'
import { useHead } from '@vueuse/head'
import { howItWorksMeta } from '@/config/meta'

useHead(howItWorksMeta)

const bannerData = ref({})
const stepsSectionData = ref({})

const qrCtaData = ref<any>({})

const { loadData } = useDynamicTranslations()

watchEffect(async () => {
  bannerData.value = await loadData('worksBanner')
  stepsSectionData.value = await loadData('stepsSection')
  qrCtaData.value = await loadData('worksQrCta')
})
</script>
